import React, { useState, useEffect, useContext } from "react";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getActiveCreditsAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const ActiveCredits = ({ selectedSucursal }) => {
  const [activeCredits, setActiveCredits] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getActiveCreditsAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setActiveCredits(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/credits`)}
      icon={<CreditCardRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="success.light"
      iconColor="success.main"
      value={activeCredits}
      label="Créditos activos"
    />
  );
};

export default ActiveCredits;
